import { Extendable, Location } from 'model';
import { AlarmSeverity } from './Alarm';


export enum AlertStatus {
  TRIGGERED, RESOLVED
}

interface AlarmReducedData {
  id: number;
  severity: AlarmSeverity;
}

export interface Alert {
  id: string;
  alarm: AlarmReducedData;
  deviceId: string;
  status: AlertStatus;
  reason: string;
  location: Extendable<Location>;
  displayTitle: string;
  displayMessage: string;
  resolutionDate: string;
  updateAt: string;
  createAt: string;
}

export function statusToString(status: AlertStatus): string {
  switch(status) {
    case AlertStatus.TRIGGERED:
      return 'Pending';
    case AlertStatus.RESOLVED:
      return 'Resolved';
  }
}

export interface AlertFilter {
  severity?: AlarmSeverity;
  status?: AlertStatus;
  page?: number;
  size?: number;
  search?: string;
  locationIds?: Array<string>;
  alarmNames?: Array<string>;
  activeOnly?: boolean; 
}

export interface AlertTotals {
  all: number;
  critical: number;
  warning: number;
  logs: number;
}

export type Alerts = {
  alerts: Alert[],
  total: number,
  page: number,
}

export interface AlertActionFilter {
  locationIds:  Array<string>;
  alarmNames:   Array<string>;
  activeOnly:   boolean;
}

export function isSmallDrip(alert: Alert): boolean {
  return [28, 29, 30, 31].includes(alert.alarm.id)
}

export function isLeakDetect(alert: Alert): boolean {
  return [100].includes(alert.alarm.id)
}

export function isCriticalAlertDetect(alert:Alert): boolean {
  return [10, 11, 26].includes(alert.alarm.id)
}

export function getSmallDripCategory(alert: Alert): number | undefined {
  switch (alert.alarm.id) {
    case 28:
      return 1;
    case 29:
      return 2;
    case 30:
      return 3;
    case 31:
      return 4;
  }
}